<template>
<div id="personal-wrap">
  <div class="personal">
    <div class="personal-header">
      <div class="header-img">
        <img :src="userInfo.headimgurl" alt="">
      </div>
    </div>
    <div class="personal-content">
      <div class="content">

        <div class="content-order conitem" @click="$router.push('/myorder')">
          <span>我的订单</span>
          <span>></span>
        </div>
        <div class="content-msg conitem" @click="$router.push('/information')">
          <span>站内信息</span>
          <span>></span>
        </div>
      </div>
    </div>
    <div class="personal-footer">
      <el-button type="primary" round @click="$router.push('/home')">返回首页</el-button>
      <el-button type="danger" round @click="$router.push('/gocat')">返回GO车惠</el-button>
    </div>
  </div>

</div>
</template>

<script>
export default {
  name: "Personal",
  data() {
    return {
      userInfo: []
    }
  },
  async created() {
    const uid = window.localStorage.getItem('uid');
    console.log(uid)
    const result = await this.$http.home.getUserInfoByUID({
      uid: uid
    })
    if (result.code === 200) {
      this.userInfo = result.data;
    } else {
      this.$message({
        message: '暂无数据。。。',
        type: 'error',
        center: true
      })
    }
  },
}
</script>

<style lang="less">
#personal-wrap {
  position: relative;
  height: 100vh;
  background: #eee;

  .personal {
    .personal-header {
      height: 240px;
      width: 100%;
      background: rgb(86, 101, 128);
      position: relative;

      .header-img {
        width: 160px;
        height: 160px;
        background: darkgoldenrod;
        border-radius: 50%;
        position: absolute;
        left: 50%;
        bottom: 30px;
        transform: translateX(-50%);
        overflow: hidden;

        img {
          width: 100%;
        }
      }
    }

    .personal-content {
      .content {
        padding: 20px 30px;

        .conitem {
          font-size: 30px;
          border: 1px solid #bbb;
          border-bottom: none;
          height: 90px;
          width: 100%;
          background: #fff;
          padding: 0 30px;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .content-msg {
          border-bottom: 1px solid #bbb;
        }
      }
    }

    .personal-footer {
      width: 100%;
      height: 100px;
      position: absolute;
      left: 0;
      bottom: 0;
      padding: 0 20px;
      display: flex;
      justify-content: space-between;
      background: #fff;
      align-items: center;

      .el-button {
        width: 45%;
        height: 60px;
        font-size: 40px;
      }
    }
  }
}
</style>
